import { IconButton } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'

export const CloseIcon = ({ fontSize, onClick }) => {
  return (
    <div
      style={{
        marginLeft: 'auto',
        marginRight: 0
      }}
    >
      <IconButton onClick={onClick} style={{ padding: 5, color: '#F67131' }}>
        <Cancel fontSize={fontSize} />
      </IconButton>
    </div>
  )
}
